import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { MasterCodeItem } from '@/shared/services/lookups';
import { warnDuplicateKeys } from '@/shared/lib/warn-duplicate-keys';

/**
 * GET /api/Master/PatientResidencyType — Citizen / Resident / Baby of Citizen
 * etc. for the patient's residency classification.
 *
 * Ships the FHIR `Code` shape `{ code, display, definition }` — NOT
 * `{ id, name }` (curl-verified 2026-06-04). Consumers key/value by `code`
 * and label by `display`; binding `.id` / `.name` yields blank pills and
 * duplicate empty-string React keys.
 */
export function usePatientResidencyTypes() {
  return useQuery({
    queryKey: ['lookup', 'patient-residency-types'],
    queryFn: async ({ signal }) => {
      const items = await get<MasterCodeItem[]>(
        '/api/Master/PatientResidencyType',
        { signal },
      );
      return warnDuplicateKeys(items ?? [], (i) => i.code, 'patient-residency');
    },
    staleTime: 60 * 60 * 1000,
  });
}
